import React, { useEffect } from 'react';
import {AppEventsLogger} from 'react-native-fbsdk-next';

import analytics from '@react-native-firebase/analytics';
import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {RootStackParamList} from '../../../../dtos/RoutesDTO';
import { SubRegionsList } from '../../../../components/shared/RegionsList/Subregions';
import { Platform } from 'react-native';
import {addInAppTrigger} from '../../../../lib/pushMessaging';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'SubRegionsMap'>;

export function SubRegionsMap({navigation, route}: ScreenProps) {
  const regiao = route.params;

  useEffect(() => {
    if(Platform.OS !== 'web'){
 addInAppTrigger('screen', 'fuel_cities');
    }

  }, []);

  async function handleRegion(cidade: string) {
    await analytics().logEvent('select_content', {
      content_type: 'mp-regiao - ' + regiao.data._id,
      item_id: regiao.data._id,
    });

    if (route.params?.callback) {
      route.params.callback({
        city: cidade,
        state: regiao.data._id,
      }); // Passa cidade e estado selecionados de volta
    }

    navigation.pop(2); // Retorna para a tela anterior
    AppEventsLogger.logEvent('clique_cidade_mapa', {cidade});
  }

  return (
    <SubRegionsList
      action={handleRegion}
      cidades={regiao.data.cidades}
      stateId={regiao.data._id}
      tipo={regiao.tipo}
    />
  );
}
